export const formatDate = (date: Date) => {
  if (!date) return "";

  const formatter = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formatter.format(date);
};

export const formatDateString = (date: string) => {
  if (!date) return "";
  
  // If we have a string
  return date.split("T")[0];
};

export const formatLastAccessDate = (dateString: Date) => {
  // Make sure it's a date
  const date = new Date(dateString);

  // Get the date parameters
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();

  // Get the time params
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
}
